import styled from 'styled-components';

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`;

export default BannerImage;
